import { createService } from "./serviceFactory";

export const categoryService = createService("activity-categories");
